import { SvgLogoProps } from 'ui/thirdPartyLogos/SvgLogo';
import { SendingPlatform, LOGO_LENGTH } from '../../constants';
import { useMetadata } from '../../hooks';
import { sendingPlatformDetailsPath } from '../../utils';
import {
  Wrapper,
  Details,
  LogoContainer,
  Title,
  Name,
  CategoryTag,
} from './IntegrationCard.styled';

type IntegrationCardProps = {
  children?: React.ReactNode;
  sendingPlatform: SendingPlatform;
};

export const IntegrationCard = ({ children, sendingPlatform }: IntegrationCardProps) => {
  const { logoSvg, name, category } = useMetadata(sendingPlatform);
  const Logo = logoSvg as React.FC<React.PropsWithChildren<SvgLogoProps>>;
  const to = sendingPlatformDetailsPath(sendingPlatform);

  return (
    <Wrapper to={to}>
      <LogoContainer>
        <Logo height={LOGO_LENGTH} width={LOGO_LENGTH} />
      </LogoContainer>
      <Title>
        <Name>{name}</Name>
        {category && <CategoryTag>{category}</CategoryTag>}
      </Title>
      <Details>{children}</Details>
    </Wrapper>
  );
};
